import React, {ChangeEvent} from 'react';
import {SvgIcon} from '../../icons/svgIcon';
import {Icons} from '../../icons/icons';
import {useTranslation} from 'react-i18next';
import {ToggleSlider} from '../../settings/toggleSlider';
import {useStateShowChatSuggestions} from '../duck/assistant-hooks';
import {useDispatch} from 'react-redux';
import {changeShowChatSuggestionsAction} from '../duck/assistant-actions';

export type ChatSuggestionsProps = {
    suggestions: string[];
    updateConversation?: (msg: string) => Promise<void>;
};

export const ChatSuggestions = ({suggestions, updateConversation}: ChatSuggestionsProps): React.JSX.Element => {
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const showSuggestions = useStateShowChatSuggestions();

    const onClick = (event: ChangeEvent<HTMLInputElement>) => {
        dispatch(changeShowChatSuggestionsAction(event.target.checked));
    };

    return (
        <div className={'suggestion-section'}>
            {showSuggestions &&
                suggestions.length > 0 &&
                suggestions.slice(-3).map((msg, index) =>
                    msg ? (
                        <div
                            key={index}
                            className={'suggestion'}
                            onClick={() => (updateConversation ? updateConversation(msg) : null)}
                        >
                            <div className={'text'}>{msg}</div>
                            <SvgIcon icon={Icons.FORWARD_ARROW} id="icon-settings" className="icon arrow" />
                        </div>
                    ) : null,
                )}
            <ToggleSlider
                name="suggestions"
                checked={showSuggestions}
                labelInfo={{id: '', label: t('search.details.hibu-assistant.suggestions.toggle')}}
                onChange={(e) => onClick(e)}
            ></ToggleSlider>
        </div>
    );
};
